import {
  GET_PURCHASEDETAIL,
  GET_PURCHASEDETAIL_SUCCESS,
  GET_PURCHASEDETAIL_FAIL,
  DELETE_PURCHASEDETAIL,
  DELETE_PURCHASEDETAIL_SUCCESS,
  DELETE_PURCHASEDETAIL_FAIL,
  UPDATE_PURCHASEDETAIL,
  UPDATE_PURCHASEDETAIL_SUCCESS,
  UPDATE_PURCHASEDETAIL_FAIL,
  ADD_NEW_PURCHASEDETAIL,
  ADD_PURCHASEDETAIL_SUCCESS,
  ADD_PURCHASEDETAIL_FAIL,
  PURCHASEDETAIL_LOADING,
  PURCHASEDETAIL_RESET,
} from "./actionType";

export const resetPurchaseDetailState = (actionType) => ({
  type: PURCHASEDETAIL_RESET,
  payload: { actionType },
});

export const getPurchaseDetailSuccess = (actionType, data) => ({
  type: GET_PURCHASEDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getPurchaseDetailFail = (actionType, error) => ({
  type: GET_PURCHASEDETAIL_FAIL,
  payload: { actionType, error },
});

export const getPurchaseDetail = data => ({
  type: GET_PURCHASEDETAIL,
  payload: data,
});

export const getPurchaseDetailLoading = () => ({
  type: PURCHASEDETAIL_LOADING
});

export const deletePurchaseDetail = data => ({
  type: DELETE_PURCHASEDETAIL,
  payload: data,
});

export const deletePurchaseDetailSuccess = data => ({
  type: DELETE_PURCHASEDETAIL_SUCCESS,
  payload: data,
});

export const deletePurchaseDetailFail = error => ({
  type: DELETE_PURCHASEDETAIL_FAIL,
  payload: error,
});

export const updatePurchaseDetail = data => ({
  type: UPDATE_PURCHASEDETAIL,
  payload: data,
});

export const updatePurchaseDetailFail = error => ({
  type: UPDATE_PURCHASEDETAIL_FAIL,
  payload: error,
});

export const updatePurchaseDetailSuccess = data => ({
  type: UPDATE_PURCHASEDETAIL_SUCCESS,
  payload: data,
});

export const addNewPurchaseDetail = data => ({
  type: ADD_NEW_PURCHASEDETAIL,
  payload: data,
});

export const addPurchaseDetailSuccess = data => ({
  type: ADD_PURCHASEDETAIL_SUCCESS,
  payload: data,
});

export const addPurchaseDetailFail = error => ({
  type: ADD_PURCHASEDETAIL_FAIL,
  payload: error,
});